import React from 'react';
import styled from '@emotion/styled';
import colors from "styles/colors";
import dimensions from "styles/dimensions";
import { Inner, gridColumns } from 'styles/structure';

const ValuesContainer = styled.div`
  background-color: ${colors.orange200};
  padding: 6.4rem 0 5.6rem;
  
  & + * {
    margin-top: 8rem;
  }
  
  @media (min-width: ${dimensions.tabletLandscapeUp}px) {
    padding: 8rem 0 7.2rem;
    
    & + * {
      margin-top: 10.4rem;
    }
  }
`;

const ValuesHeader = styled.header`
  & + * {
    margin-top: 4rem;
  }
  
  p {
    max-width: 74.8rem;
  }
  
  @media (min-width: ${dimensions.tabletLandscapeUp}px) {
    & + * {
      margin-top: 6.4rem;
    }
  }
`;

const ValuesContent = styled.ul`
  max-width: 54.6rem;
  align-items: stretch;
  justify-content: flex-start;
  
  li {        
    & + * {
      margin-top: 3.2rem;
      
      div {
        padding-top: 3.2rem;
        border-top: 1px solid ${colors.grey500}; 
      }
    }
  }
  
  h5 {
    font-weight: 500;
    
    & + * {
      margin-top: 1.6rem;
    }
  }
  
  @media (min-width: ${dimensions.tabletLandscapeUp}px) {
    max-width: none;
    display: flex;
    flex-wrap: wrap;
    
    li {
      ${gridColumns('1/2', 3.2)}
      
      padding-right: 5.6vw;
      
      div {
        height: 100%;
      }
      
      & + * {
        margin-top: 0;
        
        div {
          border-top: 0 none;
          padding-top: 0;
        }
      }
      
      &:nth-of-type(n+3) {
        margin-top: 4rem;
        
        div {
          border-top: 1px solid ${colors.grey500};
          padding-top: 4rem;
        }
      }
    }
  }
`;

const Values = ({ heading, values }) => {
  return (
    <ValuesContainer>
      <Inner>
        <ValuesHeader>
          {heading && <h3>{heading}</h3>}
        </ValuesHeader>

        <ValuesContent>
          {values && values.map((value, i) => (
            <li key={i}>
              <div>
                {value.heading && <h5>{value.heading}</h5>}
                {value.text && <p>{value.text}</p>}
              </div>
            </li>
          ))}
        </ValuesContent>
      </Inner>
    </ValuesContainer>
  );
};

export default Values;
